<template>
  <div>
    <b-card>
      <!-- <b-container class="bv-example-row btn-send-email-first-access">
        <b-row align-h="end">
          <b-col cols="2"> -->
            <b-button
              class="float-right btn-send-email-first-access"
              size="sm"
              variant="outline-success"
              @click.stop="sendEmailFirstAccess"
              v-if="isUpdate"
            >
              Enviar email primeiro acesso
            </b-button>
          <!-- </b-col>
        </b-row>
      </b-container> -->

      <b-tabs>
        <b-tab title="Usuário">
          <b-form class="custom-form" @submit.prevent autocomplete="off">
            <b-row>
              <!-- <b-col md="12">
                <div class="form-label-group">
                  <b-form-input
                    id="id"
                    placeholder="ID"
                    v-model="form._id"
                    disabled
                  />
                  <label for="id">ID</label>
                </div>
              </b-col> -->
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="username"
                    placeholder="Nome"
                    v-model="form.name"
                  />
                  <label for="username">Nome</label>
                </div>
              </b-col>
              
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email"
                    placeholder="Email"
                    type="email"
                    v-model="form.email"
                  />
                  <label for="email">Email</label>
                </div>
              </b-col>

              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    maxlength="20"
                    id="nickname"
                    placeholder="Apelido"
                    v-model="form.nickname"
                  />
                  <label for="nickname">Apelido</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    maxlength="20"
                    id="nicknameZhCn"
                    placeholder="Apelido Chines"
                    v-model="form.nicknameZhCn"
                  />
                  <label for="nicknameZhCn">Apelido Chines</label>
                </div>
              </b-col>

              <!-- <b-col md="3">
                <div class="form-label-group">
                  <b-form-input
                    id="slug"
                    placeholder="Slug"
                    v-model="form.slug"
                  />
                  <label for="slug">Slug</label>
                </div>
              </b-col> -->
              <!-- <b-col md="4">
                <div class="form-label-group">
                  <b-form-input
                    id="password"
                    placeholder="Senha"
                    type="password"
                    v-model="form.password"
                    disabled
                  />
                  <label for="password">Senha</label>
                </div>
              </b-col> -->
              <b-col md="12">
                <div class="form-label-group">
                  <b-form-textarea
                    id="resume"
                    placeholder="Resumo"
                    rows="2"
                    v-model="form.resume"
                  />
                  <label for="resume">Resumo</label>
                </div>
              </b-col>

              <b-col md="4">
                <b-form-group label="Perfil" label-for="profile-list">
                  <v-select
                    id="profile-list"
                    v-model="form.profile"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="profiles"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <div class="form-label-group">
                  <label for="country-list">País</label>
                  <b-form-group label="País" label-for="country-list">
                    <v-select
                      id="country-list"
                      v-model="form.country"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="country"
                    >
                      <span slot="no-options">{{
                        $t("GENERAL.NoOptions")
                      }}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>

             
              <b-col md="4">
                <label>Núcleo</label>
                <b-form-group>
                  <v-select
                    label="name"
                    :options="userCore"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="form.userCore"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
              </b-col>
               <!-- <b-col md="6">
                <div class="form-label-group">
                  <label for="agency-list">Agência</label>
                  <b-form-group label="Agência" label-for="agency-list">
                    <v-select
                      id="agency-list"
                      v-model="form.agency"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="agency"
                    >
                      <span slot="no-options">{{
                        $t("GENERAL.NoOptions")
                      }}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col> -->
              <!-- <b-col md="12">
                <b-form-group label="Origem" label-for="origin-list">
                  <v-select
                    id="origin-list"
                    v-model="originModel"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    multiple
                    :options="origins"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Canal" label-for="channel-list">
                  <v-select
                    id="channel-list"
                    v-model="form.channels"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    multiple
                    :options="channels"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Canal para auto-selecionar no envio de noticia" label-for="channel-list">
                  <v-select
                    id="channel-list"
                    v-model="form.channelOnSendNews"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    multiple
                    :options="form.channels"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
              </b-col> -->
              <b-col md="12">
                <b-form-group label="Assinaturas" label-for="signature-list">
                  <v-select
                    id="signature-list"
                    v-model="form.signatures"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    multiple
                    taggable
                    push-tags
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col md="12" style="margin-top: 10px">
                <div class="form-label-group">
                  <b-form-input
                    id="content-footer"
                    placeholder="Rodapé"
                    v-model="form.contentFooter"
                  />
                  <label for="content-footer">Rodapé da integra</label>
                </div>
              </b-col>

              <b-col class="mb-2" md="12"><hr /></b-col>
              <!-- <b-col md="12">
                <label>Assuntos</label>
                <b-form-group>
                  <v-select
                    label="name"
                    :options="subjects"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="subjectModel"
                    class="subject-select-field"
                  >
                    <template v-slot:option="item">
                      <p><b>{{item.name}}</b></p>
                      <p><small>Origens: {{item.originsName.join(', ')}}</small></p>
                    </template>
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col md="12" class="item-badge-select">
                <b-badge
                  variant="primary"
                  class="cursor-pointer"
                  v-for="(subject, index) in subjectsSelected"
                  :key="index"
                  @click="onRemoveSubject(subject)"
                >
                  {{ subject.name }}
                </b-badge>
              </b-col> -->
              
              <b-col md="12">
                <label>Cabeçalho</label>
                <b-form-group>
                  <v-select
                    label="name"
                    :options="userHeader"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="userHeaderModel"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col md="12" class="item-badge-select">
                <b-badge
                  variant="primary"
                  class="cursor-pointer"
                  v-for="(header, index) in userHeaderSelected"
                  :key="index"
                  @click="onRemoveUserHeader(header)"
                >
                  {{ header.name }}
                </b-badge>
              </b-col>

              <b-col md="12" class="mb-1"><hr /></b-col>
              <b-col md="12"></b-col>
              <!-- <b-col md="12">
                <div class="form-label-group">
                  <b-form-input
                    id="filters"
                    placeholder="Filtros"
                    v-model="form.filters"
                  />
                  <label for="filters">Filtros</label>
                </div>
              </b-col> -->
              <b-col md="2">
                <div class="form-label-group">
                  <b-form-input
                    id="siga_login_inicio"
                    placeholder="Siga login inicio"
                    v-model="form.siga_login_inicio"
                  />
                  <label for="siga_login_inicio">Siga login inicio</label>
                </div>
              </b-col>
              <b-col md="2">
                <div class="form-label-group">
                  <b-form-input
                    id="siga_login_termino"
                    placeholder="Siga login termino"
                    v-model="form.siga_login_termino"
                  />
                  <label for="siga_login_termino">Siga login termino</label>
                </div>
              </b-col>
              <b-col md="2">
                <div class="form-label-group">
                  <b-form-input
                    id="siga_login_atualizacao"
                    placeholder="Siga login atualização"
                    v-model="form.siga_login_atualizacao"
                  />
                  <label for="siga_login_atualizacao">Siga login atualização</label>
                </div>
              </b-col>
              <b-col md="2">
                <div class="form-label-group">
                  <b-form-input
                    id="siga_posicao"
                    placeholder="Siga posição"
                    v-model="form.siga_posicao"
                  />
                  <label for="siga_posicao">Siga posição</label>
                </div>
              </b-col>

              <b-col class="mb-2" md="12"><hr /></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    disabled
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-update"
                    placeholder="Data Alteração"
                    disabled
                  />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-update"
                    placeholder="Email Alteração"
                    disabled
                  />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-delete"
                    placeholder="Data Desativação"
                    disabled
                  />
                  <label for="dt-delete">Data Desativação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-delete"
                    placeholder="Email Desativação"
                    disabled
                  />
                  <label for="email-delete">Email Desativação</label>
                </div>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="active"
                    name="active"
                    v-model="form.active"
                  >
                    Ativo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="canCreateTag"
                    name="canCreateTag"
                    v-model="form.canCreateTag"
                  >
                    Permitir criar Tag no envio de noticia?
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="canCreateHat"
                    name="canCreateHat"
                    v-model="form.canCreateHat"
                  >
                    Permitir criar Chapéu no envio de noticia?
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="canSendSoundcloudLink"
                    name="canSendSoundcloudLink"
                    v-model="form.canSendSoundcloudLink"
                  >
                    Permitir enviar link do soundcloud
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="auth2F"
                    name="auth2F"
                    v-model="form.auth2F"
                  >
                    Autenticação 2 Fatores
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="receiveEmailAskAnalyst"
                    name="receiveEmailAskAnalyst"
                    v-model="form.receiveEmailAskAnalyst"
                  >
                    Receber email Pergunte ao Analista
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="canSendChartOnSendNews"
                    name="canSendChartOnSendNews"
                    v-model="form.canSendChartOnSendNews"
                  >
                    Permitir enviar noticia para o Gráfico
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="enableUpdateFromSiga"
                    name="enableUpdateFromSiga"
                    v-model="form.enableUpdateFromSiga"
                  >
                    Habilitar atualização do sigaweb
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col>
                <b-button
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  @click="onSubmit"
                >
                  Enviar
                </b-button>
                <b-button variant="danger" class="mr-1" @click="onBackPage">
                  Voltar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
        <b-tab title="Imagem">
          <b-row>
            <b-col md="12">
              <label for="user-image" class="mt-1">Adicione uma imagem</label>
              <b-form-file
                id="user-image"
                @change="onChangeUserImage"
                accept=".jpg, .png, .jpeg"
                placeholder="Adicione uma imagem"
                drop-placeholder="Insira uma imagem"
                browse-text="Pesquisar"
              />
            </b-col>
            <b-col md="12" v-if="displayUserImagePreview">
              <b-avatar :src="userImagePreviewSrc" size="100px" />
            </b-col>
          </b-row>
        </b-tab>
        <!-- <b-tab title="Assinatura">
          <user-register-signature
            ref="user-register-signature"
            @submit="onSubmitSignature"
            @delete="onDeleteSignature">
          </user-register-signature>
        </b-tab> -->
        <b-tab title="Pergunte ao analista" :disabled="!form.receiveEmailAskAnalyst">
          <b-row style="width: 100%">
            <b-col md="12">
              <b-form-group label="Assuntos" label-for="subject-analyst-list">
                  <v-select
                    id="subject-analyst-list"
                    v-model="form.askAnalystSubjects"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="subjectsSafrasPlatform"
                    multiple
                    :closeOnSelect="false"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <!-- <b-tab title="Apelido">
          <b-row>
             <b-col md="3">
              <div class="form-label-group">
                <b-form-input
                  maxlength="20"
                  id="nickname"
                  placeholder="Apelido"
                  v-model="form.nicknamePtBr"
                />
                <label for="nickname">Apelido PtBr</label>
              </div>
            </b-col>
          </b-row>
        </b-tab> -->
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
  BBadge,
  BFormFile,
  BAvatar,
  BFormTextarea,
  // BContainer,
  //   BInputGroup,
  //   BInputGroupAppend,
  //   BListGroup,
  //   BListGroupItem,
  //   BCardText,
  //   BFormTags,
  //   BFormTag,
  //   BFormSelect
} from "bootstrap-vue";
import vSelect from "vue-select";
import userService from "@/providers/userService";
import dropdownService from "@/providers/dropdownService";
import convertDatetimeHelper from "@/helpers/convert-datetime-helper";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
import AppConstants from '@/appConstants';
// import UserRegisterSignature from "./UserRegisterSignature.vue"

export default {
  props: {},
  data() {
    return {
      userImage: null,
      userImagePreviewSrc: "",
      displayUserImagePreview: false,
      dataID: null,
      originModel: null,
      subjectModel: null,
      subjectsSelected: [],
      signatureModel: "",
      //   userHeaderInput: "",
      //   userHeaderList: [],
      userHeaderModel: null,
      userCore: [],
      userHeaderSelected: [],
      userHeader: [],
      profiles: [],
      origins: [],
      channels: [],
      subjects: [],
      subjectsSafrasPlatform: [],
      country: [],
      agency: AppConstants.USER_AGENCY,
      form: {
        _id: "",
        name: "",
        nickname: "",
        nicknameZhCn: "",
        email: "",
        password: "",
        resume: "",
        agency: "",
        slug: "",
        active: true,
        origins: [],
        channels: [],
        channelOnSendNews: [],
        signatures: [],
        country: null,
        profile: null,
        user_header: [],
        subjects: [],
        token: "",
        url_token: "",
        dt_create: "",
        dt_update: "",
        email_create: "",
        email_update: "",
        file: null,
        contentFooter: "",
        canCreateTag: true,
        canCreateHat: true,
        canSendSoundcloudLink: false,
        auth2F: true,
        receiveEmailAskAnalyst: false,
        canSendChartOnSendNews: false,
        enableUpdateFromSiga: false,
        askAnalystSubjects: [],
        userCore: "",
        filters: "",
        siga_login_atualizacao: "",
        siga_login_inicio: "",
        siga_login_termino: "",
        siga_posicao: "",
      },
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Novo Usuário');
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
      // console.log("dataid: ", this.dataID);
    }

    this.loadData();
  },
  watch: {
    "form.name"(val) {
      if (val) {
        this.$store.dispatch("admin/updatePageTitle", val);
      } else {
        this.$store.dispatch("admin/updatePageTitle", 'Novo Usuário');
      }
    },
    originModel(val) {
      if (val.length > 0) {
        this.loadDataByOrigin();
      } else {
        this.channels = [];
        this.form.channels = [];
        this.form.channelOnSendNews = [];
        this.subjects = [];
        this.subjectsSelected = [];
      }
    },
    "form.channels"(val) {
      // console.log('form.channels: ',val)
      if (val) {
        if (val.findIndex(item => item.id == AppConstants.DROPDOWN_ALL_OPTION.id) >= 0) {
          const c = JSON.parse(JSON.stringify(this.channels));
          c.shift();
          this.form.channels = c;
        }
        this.loadSubjectByChannels()
      }
    },
    subjectModel(val) {
      //   console.log('subjectSelected: ',val)
      if (val) {
        if (val.id == AppConstants.DROPDOWN_ALL_OPTION.id) {
          // select all
          this.subjectsSelected = [];
          this.subjectsSelected = JSON.parse(JSON.stringify(this.subjects));
          this.subjectsSelected.shift();
        } else {
          const find = this.subjectsSelected.findIndex((s) => s.id == val.id);
          if (find < 0) {
            this.subjectsSelected.push(val);
          }
        }
        this.subjectModel = null;
      }
    },
    userHeaderModel(val) {
      if (val) {
        const find = this.userHeaderSelected.findIndex((s) => s.id == val.id);
        if (find < 0) {
          this.userHeaderSelected.push(val);
        }
        this.userHeaderModel = null;
      }
    },
  },
  methods: {
    onSubmitSignature(val) {
      const index = this.form.signatures.findIndex(item => item.origin.id == val.origin.id);
      if (index < 0) {
        val.origin['_id'] = val.origin.id
        this.form.signatures.push(JSON.parse(JSON.stringify(val)))
      } else {
        this.form.signatures[index] = JSON.parse(JSON.stringify(val));
      }
      this.$refs['user-register-signature'].data = [];
      this.$refs['user-register-signature'].data = JSON.parse(JSON.stringify(this.form.signatures));
    },
    onDeleteSignature(val) {
      const index = this.form.signatures.findIndex(item => item.origin.id == val.origin.id);
      if (index >= 0) {
        this.form.signatures.splice(index, 1);
        this.$refs['user-register-signature'].data = [];
        this.$refs['user-register-signature'].data = JSON.parse(JSON.stringify(this.form.signatures));
      }
    },
    sendEmailFirstAccess() {
      userService
        .sendEmailFirstAccess({_id: this.form._id}, new URLSearchParams())
        .then(() => {
          messagesNotifyHelper.successNotify("Primeiro acesso", "Email enviado com sucesso");
        })
        .catch((err) => console.log(err));
    },
    onChangeOrigin() {
      console.log("onchangeorigin");
    },
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_USER);
    },
    onSubmit() {
      const formData = new FormData();
      formData.append("avatar", this.form.file);
      formData.append("_id", this.form._id);
      formData.append("name", this.form.name);
      formData.append("email", this.form.email);
      formData.append("nickname", this.form.nickname);
      formData.append("nicknameZhCn", this.form.nicknameZhCn);
      formData.append("password", this.form.password);
      formData.append("resume", this.form.resume);
      formData.append("active", this.form.active);
      formData.append("agency", this.form.agency);
      formData.append("slug", this.form.slug);
      formData.append("contentFooter", this.form.contentFooter);
      formData.append("canCreateTag", this.form.canCreateTag);
      formData.append("canCreateHat", this.form.canCreateHat);
      formData.append("canSendSoundcloudLink", this.form.canSendSoundcloudLink);
      formData.append("auth2F", this.form.auth2F);
      formData.append("receiveEmailAskAnalyst", this.form.receiveEmailAskAnalyst);
      formData.append("canSendChartOnSendNews", this.form.canSendChartOnSendNews);
      formData.append("enableUpdateFromSiga", this.form.enableUpdateFromSiga);
      formData.append("filters", this.form.filters);
      if (this.form.siga_posicao) {
        formData.append("siga_posicao", this.form.siga_posicao);
      }
      if (this.form.siga_login_atualizacao) {
        formData.append("siga_login_atualizacao", this.form.siga_login_atualizacao);
      }
      if (this.form.siga_login_inicio) {
        formData.append("siga_login_inicio", this.form.siga_login_inicio);
      }
      if (this.form.siga_login_termino) {
        formData.append("siga_login_termino", this.form.siga_login_termino);
      }

      if (this.form.userCore) {
        formData.append(`userCore`, this.form.userCore.id);
      }
      if (this.form.signatures) {
        if (this.form.signatures.length > 0) {
          for (let index = 0; index < this.form.signatures.length; index++) {
            formData.append(`signatures[${index}]`, this.form.signatures[index]);
            // formData.append(`signatures[${index}][origin][id]`, this.form.signatures[index].origin.id);
            // formData.append(`signatures[${index}][name]`, this.form.signatures[index].name);
          }
        }
      }
      // if (this.originModel) {
      //   if (this.originModel.length > 0) {
      //     for (let index = 0; index < this.originModel.length; index++) {
      //       formData.append(`origins[${index}]`, this.originModel[index].id);
      //     }
      //   }
      // }
      if (this.userHeaderSelected) {
        if (this.userHeaderSelected.length > 0) {
          for (let index = 0; index < this.userHeaderSelected.length; index++) {
            formData.append(`user_header[${index}]`, this.userHeaderSelected[index].id);
          }
        }
      }
      // if (this.subjectsSelected) {
      //   if (this.subjectsSelected.length > 0) {
      //     for (let index = 0; index < this.subjectsSelected.length; index++) {
      //       formData.append(`subjects[${index}]`, this.subjectsSelected[index].id);
      //     }
      //   }
      // }
      // if (this.form.channels) {
      //   if (this.form.channels.length > 0) {
      //     for (let index = 0; index < this.form.channels.length; index++) {
      //       formData.append(`channels[${index}]`, this.form.channels[index].id);
      //     }
      //   }
      // }
      // if (this.form.channelOnSendNews) {
      //   if (this.form.channelOnSendNews.length > 0) {
      //     for (let index = 0; index < this.form.channelOnSendNews.length; index++) {
      //       formData.append(`channelOnSendNews[${index}]`, this.form.channelOnSendNews[index].id);
      //     }
      //   }
      // }
      if (this.form.askAnalystSubjects) {
        if (this.form.askAnalystSubjects.length > 0) {
          for (let index = 0; index < this.form.askAnalystSubjects.length; index++) {
            formData.append(`askAnalystSubjects[${index}]`, this.form.askAnalystSubjects[index].id);
          }
        }
      }
      

      if (this.form.profile) {
        formData.append("profile", this.form.profile.id);
      }
      if (this.form.country) {
        formData.append("country", this.form.country.id);
      }

      userService
        .registerUser(formData, new URLSearchParams())
        .then(() => {
          // console.log(res);
          if (this.isUpdate) {
            messagesNotifyHelper.updatedRecordNotify();
            this.checkUpdateCurrentUserLogged();
          } else {
            messagesNotifyHelper.createdRecordNotify();
            this.onBackPage();
          }
        })
        .catch((err) => console.log(err));
    },
    checkUpdateCurrentUserLogged() {
      const currentUser = this.$store.state.auth.currentUser;
      if (this.form.email == currentUser.email) {
        // console.log('checkUpdateCurrentUserLogged[name]: ', this.form.name);
        // console.log('checkUpdateCurrentUserLogged[profile]: ', this.form.profile);
        // console.log('checkUpdateCurrentUserLogged[origins]: ', this.originModel);
        currentUser.username = this.form.name;
        // currentUser.origin = this.originModel.map((item) => {
        //   return {
        //     _id: item._id,
        //     name: item.name,
        //   };
        // });
        currentUser.profile = this.form.profile.id;
        this.$store.dispatch("auth/updateCurrentUser", currentUser);
        this.$forceUpdate();
      }
    },
    onChangeUserImage(input) {
      console.log("onChangeUserImage: ", input);
      const file = input.target.files[0];
      this.form.file = file;
      if (file) {
        this.userImagePreviewSrc = URL.createObjectURL(file);
        this.displayUserImagePreview = true;
      } else {
        this.userImagePreviewSrc = "";
        this.displayUserImagePreview = false;
      }
    },
    getUserDetail() {
      const params = new URLSearchParams();
      userService
        .getUserDetails(this.dataID, params)
        .then((res) => {
          // console.log(res);
          this.form._id = res._id;
          this.form.name = res.name;
          this.form.email = res.email;
          this.form.nickname = res.nickname;
          this.form.nicknameZhCn = res.nicknameZhCn;
          this.form.resume = res.resume;
          this.form.signatures = res.signatures;
          // this.originModel = res.origins;
          this.userHeaderSelected = res.user_header;
          // this.subjectsSelected = res.subjects;
          this.form.askAnalystSubjects = res.askAnalystSubjects;
          this.form.profile = res.profile;
          this.form.country = res.country;
          // this.form.channels = res.channels;
          // this.form.channelOnSendNews = res.channelOnSendNews;
          this.form.active = res.active;
          this.form.canCreateTag = res.canCreateTag;
          this.form.canCreateHat = res.canCreateHat;
          this.form.canSendSoundcloudLink = res.canSendSoundcloudLink;
          this.form.auth2F = res.auth2F;
          this.form.contentFooter = res.contentFooter;
          this.form.agency = res.agency;
          this.form.slug = res.slug;
          this.form.receiveEmailAskAnalyst = res.receiveEmailAskAnalyst;
          this.form.canSendChartOnSendNews = res.canSendChartOnSendNews;
          this.form.enableUpdateFromSiga = res.enableUpdateFromSiga;
          this.form.userCore = res.userCore;
          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(
            res.dt_create
          );
          this.form.dt_update = res.dt_update
            ? convertDatetimeHelper.convertStringToDateTime(res.dt_update)
            : res.dt_update;
          this.form.dt_delete = res.dt_delete
            ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete)
            : res.dt_delete;

          this.form.filters = res.filters;
          this.form.siga_login_atualizacao = res.siga_login_atualizacao ? res.siga_login_atualizacao : '';
          this.form.siga_login_inicio = res.siga_login_inicio ? res.siga_login_inicio : '';
          this.form.siga_login_termino = res.siga_login_termino ? res.siga_login_termino : '';
          this.form.siga_posicao = res.siga_posicao ? res.siga_posicao : '';

          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
          this.form.email_delete = res.email_delete;

          if (res.image_path) {
            this.userImagePreviewSrc = res.image_path;
            this.displayUserImagePreview = true;
          }

          this.form.signatures = res.signatures;

          // if (this.form.signatures) {
          //   this.$refs['user-register-signature'].data = JSON.parse(JSON.stringify(this.form.signatures));
          // }
          
          // this.loadDataByOrigin();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      // const originParams = new URLSearchParams();
      // originParams.append("noApp", true);
      // originParams.append("displayInSendNews", true);
      Promise.all([
        // dropdownService.getAllOrigin(originParams),
        dropdownService.getAllProfile(new URLSearchParams()),
        dropdownService.getAllCountries(new URLSearchParams()),
        dropdownService.getAllHeader(new URLSearchParams()),
        dropdownService.getSubjectsSafrasPlatform(new URLSearchParams()),
        dropdownService.getUserCore(new URLSearchParams()),
      ])
        .then((res) => {
          // this.origins = res[0];
          this.profiles = res[0];
          this.country = res[1];
          this.userHeader = res[2];
          this.subjectsSafrasPlatform = res[3];
          this.userCore = res[4];

          // this.$refs['user-register-signature'].origins = this.origins;

          if (this.isUpdate) {
            this.getUserDetail();
          }
        })
        .catch((err) => console.log(err));
    },
    getOriginWithChannelOrigin() {
      let originList = this.originModel.map(item => item.id);
      return originList.concat(this.form.channels.filter(item => item.origin).map(item => item.origin)).join(',');
    },
    getChannelOrigin() {
      return this.form.channels.filter(item => item.origin).map(item => item.origin).join(',');
    },
    loadDataByOrigin() {
      this.channels = [];
      this.subjects = [];
      const params = new URLSearchParams();
      params.append(
        "origins",
        this.originModel.map(item => item.id)
      );
      // params.append(
      //   "origins",
      //   this.getOriginWithChannelOrigin()
      // );

      Promise.all([
        // dropdownService.getAllSubjects(params),
        dropdownService.getChannelByOrigin(params)
        ]).then((res) => {
        // this.subjects = res[0];
        // this.subjects.unshift(AppConstants.DROPDOWN_ALL_OPTION);
        this.channels = res[0];
        this.channels.unshift(AppConstants.DROPDOWN_ALL_OPTION);
      });
    },
    loadSubjectByChannels() {
      this.subjects = [];
      const params = new URLSearchParams();
      params.append(
        "origins",
        this.getChannelOrigin()
      );
      Promise.all([
        dropdownService.getAllSubjects(params),
        ]).then((res) => {
        this.subjects = res[0];
        this.subjects.unshift(AppConstants.DROPDOWN_ALL_OPTION);
      });
    },
    onAddSignature() {
      this.form.signatures.push(this.signatureModel);
      this.signatureModel = "";
    },
    onRemoveSignature(val) {
      const find = this.form.signatures.findIndex((s) => s == val);
      if (find >= 0) {
        this.form.signatures = this.form.signatures
          .filter((s) => s != val)
          .slice();
      }
    },
    onRemoveOrigin(val) {
      const find = this.originsSelected.findIndex((s) => s.id == val.id);
      if (find >= 0) {
        this.originsSelected = this.originsSelected
          .filter((s) => s.id != val.id)
          .slice();
      }
    },
    onRemoveSubject(val) {
      const find = this.subjectsSelected.findIndex((s) => s.id == val.id);
      if (find >= 0) {
        this.subjectsSelected = this.subjectsSelected
          .filter((s) => s.id != val.id)
          .slice();
      }
    },
    onAddUserHeader() {
      this.userHeaderList.push(this.userHeaderInput);
      this.userHeaderInput = "";
    },
    removeUserHeader(val) {
      const find = this.userHeaderList.findIndex((s) => s == val);
      if (find >= 0) {
        this.userHeaderList = this.userHeaderList
          .filter((s) => s.id != val.id)
          .slice();
      }
    },
    onRemoveUserHeader(val) {
      const find = this.userHeaderSelected.findIndex((s) => s.id == val.id);
      if (find >= 0) {
        this.userHeaderSelected = this.userHeaderSelected
          .filter((s) => s.id != val.id)
          .slice();
      }
    },
  },
  computed: {
    availableOptions() {
      return this.subjects.filter((opt) => this.value.indexOf(opt) === -1);
    },
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BTabs,
    BTab,
    BCard,
    BBadge,
    vSelect,
    BFormFile,
    BAvatar,
    BFormTextarea,
    // BContainer,
    // UserRegisterSignature,
    // BInputGroup,
    // BInputGroupAppend,
    // BListGroup,
    // BListGroupItem,
    // BCardText,
    // BFormTags,
    // BFormTag,
    // BFormSelect
  },
};
</script>

<style lang="scss">
.btn-send-email-first-access {
  //position: absolute;
  //z-index: 9;
  //right: 18px;
  //padding: 1px;
  margin-left: 10px;
  width: 15%;
}
</style>